import { render } from "./dispatchlist.vue?vue&type=template&id=d699bcba"
import script from "./dispatchlist.vue?vue&type=script&lang=js"
export * from "./dispatchlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__